import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import {
  RiskDistributionDto,
  RiskDistributionGroupBy,
  RiskDistributionMetric,
} from '../../../services/dtos/riskProducts/riskDistribution.dto';
import { fetchRiskDistribution } from '../../../services/riskProducts/riskProducts.service';
import { queryKeys } from '../../queryKeyFactory';

type QueryParams = {
  groupBy: RiskDistributionGroupBy;
  metric?: RiskDistributionMetric;
  rated: boolean;
};

export default (
  watchListId: string,
  { groupBy, metric, rated }: QueryParams,
  options?: UseQueryOptions<RiskDistributionDto[], Error>
): UseQueryResult<RiskDistributionDto[], Error> => {
  return useQuery<RiskDistributionDto[], Error>(
    queryKeys.fetchRiskProducts.dashboard.riskDistribution(watchListId, groupBy, metric, rated),
    async () => {
      const data = await fetchRiskDistribution(watchListId, groupBy, metric, rated);
      return data;
    },
    options
  );
};
